import { default as getConfiguration } from './get';
import { default as getStatsConfiguration } from './getStats';

export const configurations = [
  getConfiguration,
  getStatsConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/publisher/configurations/index.js